export const SAVE_CONSENT_SUCCESS = "SAVE_CONSENT_SUCCESS";
export const SAVE_CONSENT_REQUEST = "SAVE_CONSENT_REQUEST";
export const SAVE_CONSENT_ERROR = "SAVE_CONSENT_ERROR";
export const DERP_ACTION = "DERP_ACTION";
